<div class="dialog-root">
  <button
    class="close-btn"
    type="button"
    (click)="dialogRef.close()"
    routerLinkActive="router-link-active"
    aria-label="Close dialog"
  >
    <!-- thin black × (SVG, 1.5px stroke) -->
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 6L18 18M18 6L6 18"
        stroke="rgba(0,0,0,.6)"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </button>

  <div class="dialog-content">
    <!-- Your dialog content goes here -->
    <div class="dialog-container">
      <!-- Left side (15%) -->
      <div class="left-pane">
        <h2 class="hide-in-phone">Account</h2>
        <!-- <p>Links or options here</p> -->
        <ng-container *ngIf="{ user: user$ | async } as auth">
          <div
            class="menu-button"
            mat-raised-button
            *ngFor="let menu of menus; let i = index"
            (click)="
              !isMenuDisabled(menu.key, !!auth.user) && selectMenu(menu, i)
            "
            [matTooltip]="
              isMenuDisabled(menu.key, !!auth.user) ? 'Login to access' : ''
            "
            matTooltipPosition="above"
            [ngClass]="{
              'selected-class': selectedMenu === menu,
              'menu-disabled': isMenuDisabled(menu.key, !!auth.user),
            }"
            [attr.title]="
              isMenuDisabled(menu.key, !!auth.user)
                ? 'Please login to access'
                : null
            "
          >
            <div
              style="
                display: flex;
                justify-content: flex-start;
                gap: 10px;
                align-items: center;
              "
              [style.opacity]="
                isMenuDisabled(menu.key, !!auth.user) ? '0.5' : '1'
              "
            >
              <mat-icon>{{ menu.icon }}</mat-icon>
              <span class="hide-in-phone"> {{ menu.label }}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Divider -->
      <mat-divider vertical></mat-divider>

      <!-- Right side (85%) -->
      <div class="right-pane">
        <br />
        <br />
        <h3>
          {{
            selectedMenuIndex === 0 ? "Profile Settings" : selectedMenu.label
          }}
        </h3>

        <div *ngIf="selectedMenuIndex === 0" class="support-scroll">
          <div
            style="
              margin: 20px;
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: 1fr 1fr 1fr 1fr;
            "
          >
            <div style="padding: 10px">
              <h3 style="margin: 0; font-weight: 500">Avatar</h3>
              <p style="margin: 0; color: #636363">
                Upload or update your profile picture
              </p>
            </div>
            <div style="display: flex; align-items: center; gap: 10px">
              <!-- component.html -->
              <img
                style="
                  width: 50px;
                  height: 50px;
                  border-radius: 3px;
                  background-color: white;
                  object-fit: cover;
                  display: block;
                "
                *ngIf="user$ | async as user"
                [src]="userImage"
                referrerpolicy="no-referrer"
                crossorigin="anonymous"
                alt="User photo"
              />
              <div style="display: flex; align-items: center; gap: 10px">
                <!-- Edit button -->
                <button
                  mat-icon-button
                  color="primary"
                  (click)="fileInput.click()"
                >
                  <mat-icon>edit</mat-icon>
                </button>

                <!-- Hidden file input -->
                <input
                  type="file"
                  #fileInput
                  accept="image/*"
                  style="display: none"
                  (change)="onFileSelected($event)"
                />

                <!-- Delete button -->
                <button mat-icon-button color="warn" (click)="onDeletePhoto()">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div style="padding: 10px">
              <h3 style="margin: 0; font-weight: 500">Username</h3>
              <p style="margin: 0; color: #636363">
                Choose how others will see your name
              </p>
            </div>
            <div>
              <mat-form-field appearance="outline" style="width: 60%">
                <input
                  matInput
                  placeholder="Enter your username"
                  [(ngModel)]="username"
                  (ngModelChange)="onUsernameChange()"
                  (keydown.enter)="saveUsername()"
                />

                <!-- Save button (appears only when username is changed and not saving) -->
                <button
                  *ngIf="usernameChanged && !savingUsername"
                  mat-icon-button
                  matSuffix
                  aria-label="Save username"
                  matTooltip="Click to save username"
                  (click)="saveUsername()"
                >
                  <mat-icon style="color: #323232">save</mat-icon>
                </button>

                <!-- Loader (replaces save icon while saving) -->
                <mat-progress-spinner
                  *ngIf="savingUsername"
                  matSuffix
                  diameter="20"
                  mode="indeterminate"
                  style="margin-right: 10px"
                >
                </mat-progress-spinner>
              </mat-form-field>
            </div>
            <div style="padding: 10px">
              <h3 style="margin: 0; font-weight: 500">Email</h3>
              <p style="margin: 0; color: #636363">
                Update your contact email and notifications address
              </p>
            </div>
            <div>
              <mat-form-field appearance="outline" style="width: 60%">
                <input
                  disabled="true"
                  matInput
                  placeholder="Enter your email"
                  [(ngModel)]="userEmail"
                />
              </mat-form-field>
            </div>
          </div>

          <div style="grid-column: span 2; margin-top: 30px; padding: 10px">
            <mat-divider style="margin-bottom: 20px"></mat-divider>
            <h3 style="margin: 0; font-weight: 500">Deleted Projects</h3>
            <p style="margin: 0 0 15px 0; color: #636363">
              Recently deleted projects can be recovered here, unless they have
              been permanently removed.
            </p>

            <div
              *ngIf="deletedProjects$ | async as deletedProjects; else loading"
            >
              <div
                *ngIf="deletedProjects.length > 0; else noDeleted"
                style="
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                  background: #f9f9f9;
                  padding: 10px;
                  border-radius: 8px;
                "
              >
                <div
                  *ngFor="let p of deletedProjects"
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 8px 12px;
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                    background: white;
                  "
                >
                  <div>
                    <span style="font-weight: 500">{{ p.name }}</span>
                    <div style="font-size: 12px; color: #888">
                      ID: {{ p.project_id }}
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: center;
                      gap: 10px;
                    "
                  >
                    <button
                      [disabled]="p.permanently_removed === true"
                      mat-stroked-button
                      [color]="
                        p.permanently_removed !== true ? 'primary' : 'warn'
                      "
                      (click)="restoreProject(p)"
                    >
                      <mat-icon>{{
                        p.permanently_removed !== true
                          ? "restore"
                          : "remove_done"
                      }}</mat-icon>
                      {{
                        p.permanently_removed !== true
                          ? "Restore"
                          : "Permanently
                    Removed on"
                      }}
                      <span *ngIf="p.is_deleted">
                        {{ p.deleted_on | date: "long" }}
                      </span>
                    </button>
                    <button
                      *ngIf="!p.is_deleted"
                      mat-icon-button
                      color="warn"
                      matTooltip="Delete permanently (this cannot be undone)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <ng-template #noDeleted>
                <p style="font-style: italic; color: #999; padding: 10px">
                  No projects in trash.
                </p>
              </ng-template>
            </div>

            <ng-template #loading>
              <mat-spinner diameter="20"></mat-spinner>
            </ng-template>
          </div>
        </div>
        <div *ngIf="selectedMenuIndex === 1">
          <div class="support-scroll">
            <div class="billing-header-container" *ngIf="user$ | async">
              <div class="credits-glass-card">
                <div class="stat-content">
                  <div class="label-group">
                    <mat-icon class="brand-accent-icon">auto_awesome</mat-icon>
                    <span class="stat-label">Your Credits </span>
                  </div>

                  <div class="value-group">
                    <h2 class="stat-value">
                      {{ userCredits | number: "1.1-3" }}
                    </h2>
                  </div>
                </div>

                <div class="status-inline" *ngIf="paymentStatusMessage">
                  <mat-progress-spinner
                    *ngIf="isProcessingCredits"
                    diameter="16"
                    mode="indeterminate"
                    color="accent"
                  >
                  </mat-progress-spinner>
                  <span class="status-text">{{ paymentStatusMessage }}</span>
                </div>
              </div>
            </div>

            <mat-divider
              *ngIf="user$ | async"
              class="section-divider"
            ></mat-divider>
            <div class="pricing-container">
              <mat-card class="card-pricing">
                <mat-card-title>Buy 100 More Credits</mat-card-title>
                <mat-card-subtitle>Get it for ₹ 2000 only </mat-card-subtitle>
                <br />
                <mat-card-content>
                  <p>
                    Get additional credits to keep building your application.
                    What you get:
                  </p>
                  <ul>
                    <li>
                      Turn ideas into production-ready Angular components and
                      pages instantly.
                    </li>
                    <li>
                      100% custom builds styled with Angular Material and ready
                      to extend.
                    </li>
                    <li>
                      Cost-effective: 100 credits (₹2000) replaces weeks of
                      developer effort.
                    </li>
                    <li>
                      Own the generated Angular code — download, edit, and
                      deploy with no vendor lock-in.
                    </li>
                    <li>
                      Scale at your pace — test MVPs now and upgrade credits
                      when you need more.
                    </li>
                  </ul>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 20px;
                    "
                  >
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="pay(2)"
                      *ngIf="user$ | async"
                    >
                      Buy Credits
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="navigateToLogin()"
                      *ngIf="!(user$ | async)"
                    >
                      Login to Buy Credits
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card class="card-info-dark">
                <h2 class="info-title">
                  Instant credits, endless possibilities
                </h2>
                <p class="info-text">
                  Top up in seconds and keep your projects running without
                  limits.
                </p>
              </mat-card>
            </div>
          </div>
        </div>
        <div
          *ngIf="selectedMenuIndex === 2"
          class="mat-elevation-z2 table-wrapper"
        >
          <div class="table-scroll">
            <table mat-table [dataSource]="dataSource" class="mat-table">
              <!-- Date Column -->
              <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef>Oder ID</th>
                <td mat-cell *matCellDef="let row">{{ row.orderId }}</td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let row">{{ row.date }}</td>
              </ng-container>

              <!-- Item Column -->
              <ng-container matColumnDef="item">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let row">{{ row.item }}</td>
              </ng-container>

              <!-- Qty Column -->
              <ng-container matColumnDef="qty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let row">{{ row.qty }}</td>
              </ng-container>

              <!-- Amount Column -->
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>Amount</th>
                <td mat-cell *matCellDef="let row">{{ row.amount }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">{{ row.status }}</td>
              </ng-container>

              <!-- Header + Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
        <div *ngIf="selectedMenuIndex === 3">
          <!-- Ticket Raising Section -->
          <div class="support-scroll">
            <h3 style="font-weight: 500">Raise a Support Ticket</h3>
            <form
              class="ticket-form"
              #ticketForm="ngForm"
              (ngSubmit)="submitTicket(ticketForm)"
            >
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Subject</mat-label>
                <input
                  matInput
                  placeholder="Enter ticket subject"
                  [(ngModel)]="ticket.subject"
                  maxlength="80"
                  name="subject"
                  required
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Description</mat-label>
                <textarea
                  matInput
                  rows="4"
                  placeholder="Describe your issue"
                  [(ngModel)]="ticket.description"
                  name="description"
                  required
                ></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select Project (optional)</mat-label>
                <mat-select [(ngModel)]="ticket.projectId" name="projectId">
                  <mat-option [value]="null">General Support</mat-option>
                  <mat-option
                    *ngFor="let p of projects$ | async"
                    [value]="p.projectId"
                  >
                    {{ p.projectName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="btn-container">
                <button mat-raised-button color="primary" type="submit">
                  Submit Ticket
                </button>
              </div>
            </form>

            <mat-divider></mat-divider>

            <!-- Tickets List -->
            <h3 style="margin-top: 20px; font-weight: 500">Your Tickets</h3>
            <mat-accordion *ngIf="tickets$ | async as tickets">
              <ng-container *ngIf="tickets.length > 0; else noTickets">
                <mat-expansion-panel *ngFor="let t of tickets">
                  <mat-expansion-panel-header>
                    <mat-panel-title style="flex: 1 1 auto; max-width: 70%">
                      {{ t.subject }}
                    </mat-panel-title>

                    <mat-panel-description>
                      Status:
                      <span
                        [ngStyle]="{
                          color: t.status === 'open' ? 'green' : 'red',
                        }"
                      >
                        {{ t.status | titlecase }}
                      </span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <p>{{ t.description }}</p>
                  <small>Ticket ID: {{ t.id }}</small
                  ><br />
                  <small *ngIf="t.projectId"
                    >Project ID: {{ t.projectId }}</small
                  ><br />
                  <small
                    >Created:
                    {{ t.createdAt?.toDate() | date: "medium" }}</small
                  >

                  <div class="btn-container">
                    <button
                      mat-stroked-button
                      [color]="t.status === 'open' ? 'warn' : 'primary'"
                      (click)="toggleTicketStatus(t)"
                    >
                      {{
                        t.status === "open" ? "Mark as Closed" : "Reopen Ticket"
                      }}
                    </button>

                    <button
                      mat-stroked-button
                      color="warn"
                      (click)="deleteTicket(t.id)"
                    >
                      Delete
                    </button>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>

            <ng-template #noTickets>
              <p>No tickets yet.</p>
            </ng-template>

            <mat-divider></mat-divider>
          </div>
        </div>
        <div *ngIf="selectedMenuIndex === 4">
          <!-- FAQs Section -->
          <div class="support-scroll">
            <!-- <h3 style="margin-top: 20px; font-weight: 500">
              Frequently Asked Questions
            </h3> -->
            <mat-accordion>
              <mat-expansion-panel *ngFor="let faq of faqs">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ faq.question }}</mat-panel-title>
                </mat-expansion-panel-header>
                <p>{{ faq.answer }}</p>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
        <div *ngIf="selectedMenuIndex === 5">
          <div class="support-scroll">
            <h3 style="font-weight: 500">Share Your Feedback</h3>

            <form
              #feedbackForm="ngForm"
              (ngSubmit)="submitFeedback(feedbackForm)"
            >
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select Project (optional)</mat-label>
                <mat-select [(ngModel)]="feedback.projectId" name="projectId">
                  <mat-option [value]="null">General Feedback</mat-option>
                  <mat-option
                    *ngFor="let p of projects$ | async"
                    [value]="p.projectId"
                  >
                    {{ p.projectName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div
                style="
                  margin: 10px 0;
                  display: flex;
                  align-items: center;
                  gap: 5px;
                "
              >
                <span>Rating:</span>
                <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
                  <mat-icon
                    style="cursor: pointer"
                    [style.color]="feedback.rating >= star ? 'gold' : '#ccc'"
                    (click)="feedback.rating = star"
                  >
                    {{ feedback.rating >= star ? "star" : "star_border" }}
                  </mat-icon>
                </ng-container>
              </div>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Feedback</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [(ngModel)]="feedback.message"
                  name="message"
                  required
                ></textarea>
              </mat-form-field>

              <div class="btn-container">
                <button mat-raised-button color="primary" type="submit">
                  Submit Feedback
                </button>
              </div>
            </form>

            <mat-divider></mat-divider>

            <h3 style="margin-top: 20px; font-weight: 500">Your Feedback</h3>
            <mat-accordion *ngIf="feedback$ | async as feedbacks">
              <ng-container *ngIf="feedbacks.length > 0; else noFeedback">
                <mat-expansion-panel *ngFor="let f of feedbacks">
                  <mat-expansion-panel-header>
                    <mat-panel-title style="flex: 1 1 auto; max-width: 70%">
                      {{
                        f.projectId
                          ? "Project: " + f.projectId
                          : "General Feedback"
                      }}
                    </mat-panel-title>
                    <mat-panel-description>
                      <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
                        <mat-icon
                          style="font-size: 18px"
                          [style.color]="f.rating >= star ? 'gold' : '#ccc'"
                        >
                          {{ f.rating >= star ? "star" : "star_border" }}
                        </mat-icon>
                      </ng-container>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <p>{{ f.message }}</p>
                  <small
                    >Submitted:
                    {{ f.createdAt?.toDate() | date: "medium" }}</small
                  >
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>

            <ng-template #noFeedback>
              <p>No feedback shared yet.</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- <h2>Responsive Dialog</h2>
    <p>This dialog is 100% on phones, 80% on desktop.</p> -->
  </div>
</div>
